import { render, staticRenderFns } from "./EWUserDetailForm.vue?vue&type=template&id=5724705e&"
import script from "./EWUserDetailForm.vue?vue&type=script&lang=js&"
export * from "./EWUserDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports